/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { PencilIcon } from '@heroicons/react/solid';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-gray',
    },
    buttonsStyling: false,
  })
);

export const KanbanEditModal = (props: any) => {
  const {
    id: cardId,
    index,
    listId,
    show = false,
    modalTitle = 'Edit Attribute',
  } = props;

  const [title, setTitle] = useState(props.title ?? '');
  const [attributeType, setAttributeType] = useState(props.attributeType ?? '');
  const [isRequired, setRequired] = useState(props.isRequired ?? false);
  const [showOptions, setShowOptions] = useState(!!props.attributeOptions);
  const [options, setOptions] = useState<any>(props.attributeOptions ?? '');

  const onChange = () => {
    const payload = {
      listId,
      cardId,
      title,
      attributeType,
      attributeOptions: options,
      isRequired,
    };
    let hasError = false;
    if (attributeType === 'radio' && !options) {
      hasError = true;
      SwalWithBootstrapButtons.fire({
        icon: 'error',
        title: `No options entered for Selection Attribute`,
        text: `Please enter comma seperated values as options`,
        showCancelButton: false,
        confirmButtonText: 'OK',
      });
    }
    console.log(payload);
    if (!hasError) {
      return props.onChange && props.onChange(payload);
    }
  };

  const onMove = () => {
    props.onMove && props.onMove({ listId, index });
  };

  const onTitleChange = (e: any) => setTitle(e.target.value);
  const onRequiredChange = (e: any) => setRequired(e.target.checked);

  const onOptionsChange = (e: any) => {
    setOptions(e.target.value);
  };
  const onAttributeTypeChange = (e: any) => {
    setAttributeType(e.target.value);
    if (e?.target?.value === 'radio') {
      setShowOptions(true);
    }
  };
  const onHide = () => props.onHide && props.onHide();

  const _renderOptionsIf = () => {
    if (showOptions) {
      return (
        <Form.Group id="show-options" className="mb-3">
          <Form.Control
            required
            autoFocus
            type="text"
            value={options}
            onChange={onOptionsChange}
            placeholder={
              'Enter options as comma separated value for user to pick'
            }
          />
        </Form.Group>
      );
    }
  };

  return (
    <Modal as={Modal.Dialog} centered show={show} onHide={onHide}>
      <Form className="modal-content p-3">
        <Modal.Header className="pb-0 border-0">
          <h5 as={Modal.Title} className="fw-normal">
            {modalTitle}
          </h5>
          <Button variant="close" onClick={onHide} />
        </Modal.Header>
        <Modal.Body className="pb-0">
          <Form.Group id="title" className="mb-3">
            <Form.Control
              required
              autoFocus
              type="text"
              value={title}
              defaultValue={props.titleDefaultValue}
              onChange={onTitleChange}
              placeholder={props.titlePlaceholder}
            />
          </Form.Group>
          <Form.Group id="description" className="mb-3">
            <Form.Select
              onChange={onAttributeTypeChange}
              // defaultValue={props.attributeTypeDefaultValue}
              value={attributeType}
            >
              <option>{props.attributeTypePlaceholder}</option>
              {props.attributeTypeValue?.map((desc: any, index: number) => (
                <option
                  key={`kanban-create-modal-${desc.value}-${index}`}
                  value={desc?.value}
                >
                  {desc?.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          {_renderOptionsIf()}
          <Form.Group id="required" className="mb-3">
            <Form.Check
              label={props.requiredLabel}
              onChange={onRequiredChange}
              checked={isRequired}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0 pt-0">
          <Button variant="outline-gray-500" onClick={onHide}>
            {props.closeButtonLabel}
          </Button>
          <Button
            variant="secondary"
            className="d-inline-flex align-items-center"
            onClick={onChange}
          >
            <PencilIcon className="icon icon-xs me-2" />
            Edit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

KanbanEditModal.defaultProps = {
  requiredLabel: 'Required',
  closeButtonLabel: 'Close',
  attributeTypeValue: [],
};
